module.exports = __webpack_public_path__ + "static/media/om_beard_stubble_round_hazel.36c2c3c6.png";